import { SEG_LIST } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  segments: [],
  fetchSegmentsStatus: null,
  selectedSegmentIds: [],
  selectedClusterIds: [],
  gridState: {
    sortBy: [{ id: 'onboarded', desc: true, find: () => {}, findIndex: () => {} }],
  },
  controlledGridState: {
    sortBy: [{ id: 'onboarded', desc: true, find: () => {}, findIndex: () => {} }],
  },
  selectedGridRows: [],
  maxGridRowSelection: 3,
  editSegmentStatus: null,
  editClusterStatus: null,
  editDatasetStatus: null,
  createModelStatus: null,
  models: [],
  fetchModelsStatus: null,
  fetchModelsError: null,
  addModelTargetStatus: null,
  addModelTargetError: null,
  deleteSegmentStatus: null,
  checkDeleteSegmentStatus: null,
  checkDeleteSegmentDependents: [],
  checkDeleteSegmentError: null,
  downloadUrl: null,
  fetchDownloadUrlStatus: null,
  fetchDownloadUrlError: null,
  deleteDownloadStatus: null,
  deleteDownloadError: null,
  visibilityDownloadStatus: null,
  visibilityDownloadError: null,
  client: null,
  fetchClientByTenantStatus: null,
  fetchClientByTenantError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEG_LIST.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case SEG_LIST.FETCH_CLIENT_BY_TENANT:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.FETCH_CLIENT_BY_TENANT_SUCCEEDED:
      return {
        ...state,
        client: action.payload,
        fetchClientByTenantStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.FETCH_CLIENT_BY_TENANT_FAILED:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.FAILED,
        fetchClientByTenantError: action.payload,
      };
    case SEG_LIST.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.DESELECT_ALL_SEGMENT_IDS:
      return {
        ...state,
        controlledGridState: {
          ...state.controlledGridState,
          selectedRowIds: {},
        },
        selectedSegmentIds: [],
        selectedClusterIds: [],
        selectedGridRows: [],
      };
    case SEG_LIST.SET_GRID_STATE:
      return {
        ...state,
        gridState: action.payload,
        controlledGridState: {},
      };
    case SEG_LIST.SET_SELECTED_GRID_ROWS:
      return {
        ...state,
        selectedGridRows: action.payload,
        selectedSegmentIds: action.payload
          .map(({ original: { id, datasetId } }) => (datasetId ? { segmentId: id, datasetId } : null))
          .filter((id) => id),
        selectedClusterIds: action.payload
          .map(({ original: { id, segmentId } }) => (segmentId ? { clusterId: id, segmentId } : null))
          .filter((value) => value),
        controlledGridState: {
          ...state.controlledGridState,
          selectedRowIds: Object.fromEntries(action.payload.map(({ id }) => [id, true])),
        },
      };
    case SEG_LIST.EDIT_SEGMENT:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.EDIT_SEGMENT_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.id === action.payload.id ? { ...segment, ...action.payload.payload } : segment
        ),
        editSegmentStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.EDIT_SEGMENT_FAILED:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.EDIT_CLUSTER:
      return {
        ...state,
        editClusterStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.EDIT_CLUSTER_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.id === action.payload.parentId
            ? {
                ...segment,
                clusters: segment.clusters.map((cluster) =>
                  cluster.id === action.payload.id
                    ? {
                        ...cluster,
                        ...action.payload.payload,
                      }
                    : cluster
                ),
              }
            : segment
        ),
        editClusterStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.EDIT_CLUSTER_FAILED:
      return {
        ...state,
        editClusterStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.EDIT_DATASET:
      return {
        ...state,
        editDatasetStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.EDIT_DATASET_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.dataset.id === action.payload.id
            ? {
                ...segment,
                dataset: {
                  ...segment.dataset,
                  ...action.payload.payload,
                },
              }
            : segment
        ),
        editDatasetStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.EDIT_DATASET_FAILED:
      return {
        ...state,
        editDatasetStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.CREATE_MODEL:
      return {
        ...state,
        createModelStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.CREATE_MODEL_SUCCEEDED:
      return {
        ...state,
        createModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.CREATE_MODEL_FAILED:
      return {
        ...state,
        createModelStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.ADD_MODEL_TARGET:
      return {
        ...state,
        addModelTargetStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.ADD_MODEL_TARGET_SUCCEEDED:
      return {
        ...state,
        addModelTargetStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.ADD_MODEL_TARGET_FAILED:
      return {
        ...state,
        addModelTargetStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.FETCH_MODELS:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.FETCH_MODELS_SUCCEEDED:
      return {
        ...state,
        models: action.payload,
        fetchModelsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.FETCH_MODELS_FAILED:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.DELETE_SEGMENT:
      return {
        ...state,
        deleteSegmentStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.DELETE_SEGMENT_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.filter(({ id }) => id !== action.payload),
        deleteSegmentStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.DELETE_SEGMENT_FAILED:
      return {
        ...state,
        deleteSegmentStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.CHECK_DELETE_SEGMENT:
      return {
        ...state,
        checkDeleteSegmentStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.CHECK_DELETE_SEGMENT_SUCCEEDED:
      return {
        ...state,
        checkDeleteSegmentDependents: action.payload,
        checkDeleteSegmentStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.CHECK_DELETE_SEGMENT_FAILED:
      return {
        ...state,
        checkDeleteSegmentStatus: CONSTANTS.API.FAILED,
        checkDeleteSegmentError: action.payload,
      };
    case SEG_LIST.DELETE_CLUSTER:
      return {
        ...state,
        deleteClusterStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.DELETE_CLUSTER_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.id === action.payload.parentId
            ? {
                ...segment,
                clusters: segment.clusters.filter(({ id }) => id !== action.payload.id),
              }
            : segment
        ),
        deleteClusterStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.DELETE_CLUSTER_FAILED:
      return {
        ...state,
        deleteClusterStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.FETCH_DOWNLOAD_URL:
      return {
        ...state,
        fetchDownloadUrlStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.FETCH_DOWNLOAD_URL_SUCCEEDED:
      return {
        ...state,
        downloadUrl: action.payload,
        fetchDownloadUrlStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.FETCH_DOWNLOAD_URL_FAILED:
      return {
        ...state,
        fetchDownloadUrlError: action.payload,
        fetchDownloadUrlStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.DELETE_DOWNLOAD:
      return {
        ...state,
        deleteDownloadStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.DELETE_DOWNLOAD_SUCCEEDED:
      return {
        ...state,
        deleteDownloadStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.DELETE_DOWNLOAD_FAILED:
      return {
        ...state,
        deleteDownloadError: action.payload,
        deleteDownloadStatus: CONSTANTS.API.FAILED,
      };
    case SEG_LIST.TOGGLE_VISIBILITY_DOWNLOAD:
      return {
        ...state,
        visibilityDownloadStatus: CONSTANTS.API.STARTED,
      };
    case SEG_LIST.TOGGLE_VISIBILITY_DOWNLOAD_SUCCEEDED:
      return {
        ...state,
        visibilityDownloadStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_LIST.TOGGLE_VISIBILITY_DOWNLOAD_FAILED:
      return {
        ...state,
        visibilityDownloadError: action.payload,
        visibilityDownloadStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
